import Reveal from "@/components/site/Reveal";
import { IMG } from "@/lib/site";
import { useT } from "@/lib/i18n";

const HomeModalities = () => {
  const t = useT();
  const modalities = [
    { title: t("home.mod.individual.title"), body: t("home.mod.individual.body"), img: IMG.sessionSofa },
    { title: t("home.mod.bcn.title"), body: t("home.mod.bcn.body"), img: IMG.yogaAdjusting },
    { title: t("home.mod.group.title"), body: t("home.mod.group.body"), img: IMG.yogaBuddha },
    { title: t("home.mod.workshops.title"), body: t("home.mod.workshops.body"), img: IMG.hospitalSavasana },
  ];

  return (
    <section className="py-24 md:py-32" data-testid="modalities-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <Reveal className="max-w-2xl mb-14">
          <p className="text-[11px] tracking-[0.32em] uppercase text-sage mb-6">{t("home.modalities.eyebrow")}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal leading-[1.05]">
            {t("home.modalities.title1")} <span className="italic">{t("home.modalities.title2")}</span>.
          </h2>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {modalities.map((m, i) => (
            <Reveal key={m.title} delay={i * 0.08}>
              <article className="group bg-ivory rounded-3xl overflow-hidden border border-sand/60 hover:shadow-xl hover:shadow-charcoal/5 transition-all h-full">
                <div className="aspect-[4/5] overflow-hidden">
                  <img src={m.img} alt={m.title} className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700" loading="lazy" decoding="async" />
                </div>
                <div className="p-7">
                  <h3 className="font-serif text-2xl text-charcoal">{m.title}</h3>
                  <p className="mt-3 text-charcoal/65 leading-relaxed text-[14px]">{m.body}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeModalities;
